/**
 * Custom logger middleware for Redux in Vite
 */
export const loggerMiddleware = (store) => (next) => (action) => {
  if (import.meta.env.VITE_NODE_ENV !== 'production') {
    console.group(`🔄 Redux Action: ${action.type}`);
    console.log('Previous State:', store.getState());
    console.log('Action:', action);
    
    const result = next(action);
    
    console.log('Next State:', store.getState());
    console.groupEnd();
    
    return result;
  }
  
  return next(action);
};